// Refresh-on-arrival for list pages kept alive by the taskbar.
// Spec: docs/specs/2026-10-07-bo-refresh-on-arrival-catalog-coupon-design.md §3
// (mechanism: 2026-10-07-bo-orders-refresh-on-arrival-design.md, src/utils/pageRefresh.js).
//
// A page using this mixin must define `reloadOnArrival(intent)` (calls its own
// loader). mounted() keeps loading as before and should call
// consumeRefresh(this.$route.fullPath) to discard a stale flag, so the first
// activation after a fresh mount never refreshes a second time.
//
// The first activated() follows mounted() and is skipped; later activations
// refresh only when arrivalIntent says the arrival carries intent (a sender
// called requestRefresh(<list path>) before navigating). A plain tab switch
// does nothing. Vue merges a page's own created/activated after these.
//
// Consumers: AppCatalog/Products.vue, AppCatalog/Promotions.vue,
// AppCatalog/PromotionBundles.vue, Coupon/CouponTables.vue.
// Pinned by tests/unit/refreshOnArrivalMixin.spec.js and
// tests/unit/refreshOnArrivalCatalogSource.spec.js.
import { arrivalIntent } from "@/utils/pageRefresh";

export default {
	created() {
		// Non-reactive on purpose: not in data().
		this.activatedOnce = false;
	},
	activated() {
		if (!this.activatedOnce) {
			this.activatedOnce = true; // first activation = mounted() already loaded
			return;
		}
		const intent = arrivalIntent(this.$route);
		if (!intent.refresh) return; // plain tab switch
		if (typeof this.reloadOnArrival === "function") this.reloadOnArrival(intent);
	}
};
